module.exports = __webpack_public_path__ + "img/C.dc6b32ea.png";